module.exports = __webpack_public_path__ + "static/media/DashboardIconInactive.528c5119.png";